export var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["KILL_STRIKE"] = 0] = "KILL_STRIKE";
    NotificationType[NotificationType["LEVEL_UP"] = 1] = "LEVEL_UP";
    NotificationType[NotificationType["EXP"] = 2] = "EXP";
    NotificationType[NotificationType["DEATH"] = 3] = "DEATH";
})(NotificationType || (NotificationType = {}));
